<!-- 操作面板 -->
<template>
    <div>
        <div class="card">
            <div class="title">{{ newFormData.name }}</div>
        </div>
        <div class="card mb0">
            <Menu
                mode="horizontal"
                :active-name="name_id"
                @on-select="selectName"
            >
                <MenuItem name="1" class="head-text">内容设置</MenuItem>
                <MenuItem name="2" class="head-text">样式设置</MenuItem>
                <MenuItem name="3" class="head-text">边距设置</MenuItem>
            </Menu>
            <div class="mt24 mb24">
                <!-- 内容设置 -->
                <div v-if="name_id == 1">
                    <template v-if="newFormData.content.style_value == '1'">
                        <div class="form-title">操作标题</div>
                        <Form
                            :model="newFormData"
                            label-position="right"
                            :label-width="100"
                        >
                            <FormItem label="标题文字">
                                <Input
                                    v-model="newFormData.content.title"
                                    placeholder="请输入标题文字"
                                ></Input>
                            </FormItem>
                            <FormItem label="文字大小">
                                <Input
                                    v-model="newFormData.content.title_size"
                                    placeholder="请输入文字大小"
                                    ><span slot="append">PX</span></Input
                                >
                            </FormItem>
                            <FormItem label="标题颜色">
                                <ColorPicker
                                    v-model="newFormData.content.title_color"
                                />
                            </FormItem>
                        </Form>
                    </template>
                    <!-- 操作面板列表：数据由 template_diy_form_list 接口回显，
                         每一项是一个操作项，可单独编辑、保存、删除 -->
                    <div class="form-title">操作面板</div>
                    <div class="status-list-box">
                        <template v-if="newFormData.content.style_value == '1'">
                            <div
                                class="status-item"
                                v-for="(item, index) in newFormData.content
                                    .controlList"
                                :key="index"
                            >
                                <div class="item-actions">
                                    <span
                                        class="action-link"
                                        @click="moveStatus(index, -1)"
                                        >上移</span
                                    >
                                    <span
                                        class="action-link"
                                        @click="moveStatus(index, 1)"
                                        >下移</span
                                    >
                                    <span
                                        class="action-link"
                                        @click="addStatus(index)"
                                        >编辑</span
                                    >
                                    <div
                                        class="del-btn"
                                        @click="delStatus(index)"
                                    >
                                        <Icon type="ios-trash" color="#fff" />
                                    </div>
                                </div>
                                <div class="control-grid">
                                    <div>
                                        <div class="control-name">
                                            {{ item.btn_title }}
                                        </div>
                                        <div>
                                            {{ item.btn_desc }}
                                        </div>
                                    </div>
                                    <Button
                                        class="theme-bc theme-default-color"
                                        @click="addStatus(index)"
                                        >{{ item.btn_text }}</Button
                                    >
                                </div>
                            </div>
                            <div class="add-status" @click="addStatus(-1)">
                                <Icon type="md-add" size="20" color="#FF761D" />
                                <span>添加操作</span>
                            </div>
                        </template>
                        <div v-else class="add-status" @click="editStatus(0)">
                            <Icon type="md-add" size="20" color="#FF761D" />
                            <span>编辑</span>
                        </div>
                    </div>
                </div>

                <!-- 样式设置 -->
                <div v-if="name_id == 2">
                    <Form
                        :model="newFormData"
                        label-position="right"
                        :label-width="100"
                    >
                        <div class="form-title">选择样式</div>
                        <div class="style-select">
                            <div class="section-label">样式一</div>
                            <div
                                :class="
                                    newFormData.content.style_value == '1'
                                        ? 'style-card style-card-active'
                                        : 'style-card'
                                "
                                @click="changeStyle('1')"
                            >
                                <img src="@/assets/control-1.png" class="w1" />
                            </div>
                            <div class="section-label mt12">样式二</div>
                            <div
                                :class="
                                    newFormData.content.style_value == '2'
                                        ? 'style-card style-card-active'
                                        : 'style-card'
                                "
                                @click="changeStyle('2')"
                            >
                                <img src="@/assets/control-2.png" class="w1" />
                                <div class="control-tip">
                                    只使用一个表单填写，多表单不可使用
                                </div>
                            </div>
                        </div>
                        <div class="form-title">背景设置</div>
                        <FormItem label="背景颜色">
                            <ColorPicker
                                v-model="newFormData.content.bg_color"
                            />
                        </FormItem>
                        <FormItem label="背景图">
                            <i-switch
                                v-model="newFormData.content.bg_value"
                                size="large"
                                true-color="#FF761D "
                                :true-value="1"
                                :false-value="0"
                                @on-change="changeBgValue"
                            >
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </FormItem>
                        <FormItem
                            v-if="newFormData.content.bg_value"
                            label="上传背景"
                        >
                            <div class="bg-upload" @click="openPicModal">
                                <img
                                    class="bg-img"
                                    v-if="newFormData.content.bg_img.picview"
                                    :src="newFormData.content.bg_img.picview"
                                />
                                <Icon
                                    v-else
                                    type="md-add"
                                    size="30"
                                    color="#ccc"
                                />
                            </div>
                        </FormItem>
                    </Form>
                </div>

                <!-- 边距设置 -->
                <div v-if="name_id == 3">
                    <Form
                        :model="newFormData"
                        label-position="right"
                        :label-width="80"
                    >
                        <div class="form-title">外间距</div>
                        <FormItem label="上下间距"
                            ><Slider
                                v-if="newFormData.content.marginData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.marginData.top"
                            ></Slider
                        ></FormItem>
                        <FormItem label="左右间距"
                            ><Slider
                                v-if="newFormData.content.marginData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.marginData.left"
                            ></Slider
                        ></FormItem>
                        <div class="form-title">内间距</div>
                        <FormItem label="上下间距"
                            ><Slider
                                v-if="newFormData.content.paddingData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.paddingData.top"
                            ></Slider
                        ></FormItem>
                        <FormItem label="左右间距"
                            ><Slider
                                v-if="newFormData.content.paddingData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.paddingData.left"
                            ></Slider
                        ></FormItem>
                        <div class="form-title">圆角设置</div>
                        <FormItem label="上圆角"
                            ><Slider
                                v-if="newFormData.content.radiusData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.radiusData.top"
                            ></Slider
                        ></FormItem>
                        <FormItem label="下圆角"
                            ><Slider
                                v-if="newFormData.content.radiusData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.radiusData.bottom"
                            ></Slider
                        ></FormItem>
                    </Form>
                </div>
            </div>
        </div>

        <!-- 新增操作/编辑 -->
        <Modal
            v-model="addModal"
            :title="addTitle"
            :width="600"
            :mask-closable="false"
        >
            <div class="form-div">
                <Form
                    :model="form_data"
                    label-position="right"
                    :label-width="100"
                >
                    <FormItem label="添加表单">
                        <Button
                            v-if="formList.length < 3"
                            type="warning"
                            ghost
                            @click="addForm"
                            >创建表单</Button
                        >
                        <div v-else class="edit-div">
                            <div class="edit-name">{{ getTypeName }}</div>
                            <p class="edit-txt">{{ allNameList }}</p>
                            <Button class="mr12" type="warning" @click="addForm"
                                >修改表单</Button
                            >
                            <Button type="warning" ghost @click="addRule"
                                >表单规则</Button
                            >
                        </div>
                    </FormItem>
                    <FormItem
                        v-if="newFormData.content.style_value == '1'"
                        label="操作标题"
                    >
                        <Input
                            class="w300"
                            v-model="form_data.btn_title"
                            placeholder="请输入操作标题"
                        ></Input
                        ><ColorPicker
                            v-model="form_data.btn_title_color"
                            class="ml12"
                        />
                    </FormItem>
                    <FormItem
                        v-if="newFormData.content.style_value == '1'"
                        label="操作说明"
                    >
                        <Input
                            class="w300"
                            v-model="form_data.btn_desc"
                            placeholder="请输入操作说明"
                        ></Input
                        ><ColorPicker
                            v-model="form_data.btn_desc_color"
                            class="ml12"
                        />
                    </FormItem>
                    <FormItem
                        v-if="newFormData.content.style_value == '1'"
                        label="操作按钮"
                    >
                        <Input
                            class="w300"
                            v-model="form_data.btn_text"
                            placeholder="请输入操作按钮"
                        ></Input
                        ><ColorPicker
                            v-model="form_data.btn_text_color"
                            class="ml12"
                        />
                    </FormItem>
                    <FormItem
                        v-if="newFormData.content.style_value == '1'"
                        label="按钮颜色"
                    >
                        <ColorPicker v-model="form_data.btn_color" />
                    </FormItem>
                    <FormItem
                        v-if="newFormData.content.style_value == '1'"
                        label="边框颜色"
                    >
                        <ColorPicker v-model="form_data.border_color" />
                    </FormItem>
                    <FormItem
                        v-if="newFormData.content.style_value == '1'"
                        label="操作背景"
                    >
                        <ColorPicker v-model="form_data.bg_color" />
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="addModal = false">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="saveStatusEdit"
                    >确定</Button
                >
            </div>
        </Modal>

        <!-- 表单规则 -->
        <Modal
            v-model="ruleModal"
            title="次数与时间限制"
            :width="600"
            :mask-closable="false"
        >
            <div>
                <Form
                    :model="rule_data"
                    label-position="right"
                    :label-width="120"
                >
                    <FormItem label="谁能填写">
                        <RadioGroup v-model="rule_data.who_type" vertical>
                            <Radio label="0">所有人</Radio>
                            <div class="radio-tip">
                                完全公开，任何人扫码都能操作，公开后表单记录所有人可见，请确保合法合规
                            </div>
                            <Radio label="1">全部成员</Radio>
                            <Radio label="2">指定成员</Radio>
                        </RadioGroup>
                        <Select
                            v-if="rule_data.who_type == '2'"
                            v-model="rule_data.customer_ids"
                            class="w200"
                            multiple
                            filterable
                            placeholder="请选择成员"
                        >
                            <Option
                                v-for="m in member_list"
                                :value="m.id"
                                :key="m.id"
                                :label="m.name"
                            />
                        </Select>
                    </FormItem>
                    <FormItem label="每人可填写次数">
                        <RadioGroup
                            v-model="rule_data.per_user_limit_type"
                            vertical
                        >
                            <Radio label="0">不限制</Radio>
                            <Radio label="1">每个二维码每人填写一次</Radio>
                            <Radio label="2">自定义</Radio>
                        </RadioGroup>
                        <div v-if="rule_data.per_user_limit_type == '2'">
                            每个二维码每人每
                            <Input
                                class="w50"
                                v-model="rule_data.per_user_days"
                            ></Input>
                            天 可填写
                            <Input
                                class="w50"
                                v-model="rule_data.per_user_count"
                            ></Input
                            >次
                        </div>
                    </FormItem>
                    <FormItem label="表单可填写总数">
                        <RadioGroup
                            v-model="rule_data.total_limit_type"
                            vertical
                        >
                            <Radio label="0">不限制</Radio>
                            <Radio label="1"
                                >每个二维码该表单总共可填写<Input
                                    class="w50"
                                    v-model="rule_data.total_count"
                                ></Input
                                >次</Radio
                            >
                            <Radio label="2">自定义</Radio>
                        </RadioGroup>
                        <div v-if="rule_data.total_limit_type == '2'">
                            每个二维码该表单每<Input
                                class="w50"
                                v-model="rule_data.total_days"
                            ></Input>
                            天 可填写
                            <Input
                                class="w50"
                                v-model="rule_data.total_count"
                            ></Input
                            >次
                        </div>
                    </FormItem>
                    <FormItem label="可填写时间段">
                        <RadioGroup
                            v-model="rule_data.time_limit_type"
                            vertical
                        >
                            <Radio label="0">不限制</Radio>
                            <Radio label="1">设置开始/停止时间</Radio>
                        </RadioGroup>
                        <div
                            v-if="rule_data.time_limit_type == '1'"
                            class="time-range"
                        >
                            <DatePicker
                                style="width: 180px"
                                type="datetime"
                                :value="rule_data.start_time"
                                placeholder="请选择开始时间"
                                @on-change="handleStartTimeChange"
                            />
                            <span class="time-sep">~</span>
                            <DatePicker
                                style="width: 180px"
                                type="datetime"
                                :value="rule_data.end_time"
                                placeholder="请选择结束时间"
                                @on-change="handleEndTimeChange"
                            />
                        </div>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="ruleModal = false">取消</Button>
                <Button class="theme-bc theme-default-color" @click="submitRule"
                    >确定</Button
                >
            </div>
        </Modal>

        <!-- 新增表单/修改表单 -->
        <Modal
            v-model="formModal"
            title="新增表单"
            :width="90"
            :mask-closable="false"
            class="form-modal"
        >
            <div>
                <addForm
                    :formList="formList"
                    @submit="handleFormSubmit"
                ></addForm>
            </div>
            <div slot="footer"></div>
        </Modal>

        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="select"
            :select_type="select_type"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
// 操作面板相关接口：
//   template_diy_form_list —— 获取操作面板操作项列表（回显）
//   template_diy_form_save —— 保存单个操作项（新增/编辑）
//   template_diy_form_del  —— 删除单个操作项
import {
    template_diy_form_list,
    template_diy_form_save,
    template_diy_form_del,
} from "@/api/diyForm";
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
import addForm from "@/components/addForm/addForm.vue";
import { customer_select } from "@/api/index";

// 生成表单字段唯一标识 field_key（与 addForm 组件保持一致的格式）
function generateFieldKey(type) {
    let admin_id = "";
    try {
        admin_id = localStorage.getItem("admin_id") || "";
    } catch (e) {
        // 忽略 localStorage 不可用的情况
    }
    return (
        admin_id +
        "_" +
        type +
        "_" +
        Date.now() +
        "_" +
        Math.random().toString(36).slice(2, 6)
    );
}

export default {
    components: {
        pictureLibrary,
        addForm,
    },
    props: {
        newFormData: {
            type: Object,
            default: {},
        },
        content_id: {
            type: [String, Number],
            default: "",
        },
    },
    data() {
        return {
            select: 1,
            select_type: "image",
            switch_modal: false,
            name_id: "1",
            addModal: false,
            addTitle: "新增操作",
            form_data: {
                btn_title: "操作标题",
                btn_desc: "操作说明",
                btn_text: "操作",
                btn_title_color: "#000",
                btn_desc_color: "#666",
                btn_text_color: "#fff",
                btn_color: "#FF761D",
                border_color: "#FF761D",
                bg_color: "#f2f7fa",
            },
            formModal: false,
            // 当前编辑的操作项索引，-1 表示新增
            editIndex: -1,
            // 传给 addForm 的表单数据，也用于接收 addForm 回传
            formList: [
                {
                    type: 1,
                    field_key: generateFieldKey(1),
                    name: "表单名称",
                    content: {
                        title: "表单名称",
                        title_size: "18",
                        title_color: "#000",
                        title_position: "center",
                        bg_color: "#fff",
                        bg_value: 0,
                        bg_img: {
                            value: "",
                            picview: "",
                        },
                        outer_spacing: {
                            top: 0,
                            left: 0,
                        },
                        inner_spacing: {
                            top: 12,
                            left: 12,
                        },
                        rounded_corner_setting: {
                            top: 0,
                            bottom: 0,
                        },
                    },
                },
                {
                    type: 20,
                    field_key: generateFieldKey(20),
                    name: "提交按钮",
                    content: {
                        title: "提交",
                        title_color: "#fff",
                        border_color: "#FF761D",
                        button_submit_color: "#FF761D",
                        cannot_submit_border_color: "#666",
                        button_cannot_submit_color: "#666",
                        bg_color: "#fff",
                        bg_value: 0,
                        bg_img: {
                            value: "",
                            picview: "",
                        },
                        outer_spacing: {
                            top: 12,
                            left: 12,
                        },
                        inner_spacing: {
                            top: 6,
                            left: 0,
                        },
                        rounded_corner_setting: {
                            top: 20,
                            bottom: 20,
                        },
                    },
                },
            ],
            ruleModal: false,
            rule_data: {
                who_type: "0",
                customer_ids: [],
                per_user_limit_type: "0",
                per_user_days: "",
                per_user_count: "",
                total_limit_type: "0",
                total_count: "",
                total_days: "",
                time_limit_type: "0",
                start_time: "",
                end_time: "",
            },
            member_list: [],
            admin_id: "",
        };
    },
    created() {
        try {
            this.admin_id = localStorage.getItem("admin_id") || "";
        } catch (e) {
            this.admin_id = "";
        }
        this.ensureComponentKey();
        this.ensureControlList();
        this.getMemberList();
        this.loadControlList();
    },
    computed: {
        getTypeName() {
            const item = this.formList.find((el) => el.type === 1);
            return item.content.title;
        },
        allNameList() {
            const arr = this.formList.map((item) => item.name);
            return `包含${arr.join("、")}等${arr.length}个字段`;
        },
    },
    methods: {
        // 确保组件 key 存在（接口定位用 component_key）
        ensureComponentKey() {
            if (!this.newFormData.key) {
                this.$set(
                    this.newFormData,
                    "key",
                    this.admin_id + "a" + Date.now()
                );
            }
        },
        // 确保 controlList 是数组，避免 v-for 访问报错
        ensureControlList() {
            if (!Array.isArray(this.newFormData.content.controlList)) {
                this.$set(this.newFormData.content, "controlList", []);
            }
        },
        // 创建默认表单设计数据（新建操作项时的初始表单）
        getDefaultFormList() {
            return [
                {
                    type: 1,
                    field_key: generateFieldKey(1),
                    name: "表单名称",
                    content: {
                        title: "表单名称",
                        title_size: "18",
                        title_color: "#000",
                        title_position: "center",
                        bg_color: "#fff",
                        bg_value: 0,
                        bg_img: {
                            value: "",
                            picview: "",
                        },
                        outer_spacing: {
                            top: 0,
                            left: 0,
                        },
                        inner_spacing: {
                            top: 12,
                            left: 12,
                        },
                        rounded_corner_setting: {
                            top: 0,
                            bottom: 0,
                        },
                    },
                },
                {
                    type: 20,
                    field_key: generateFieldKey(20),
                    name: "提交按钮",
                    content: {
                        title: "提交",
                        title_color: "#fff",
                        border_color: "#FF761D",
                        button_submit_color: "#FF761D",
                        cannot_submit_border_color: "#666",
                        button_cannot_submit_color: "#666",
                        bg_color: "#fff",
                        bg_value: 0,
                        bg_img: {
                            value: "",
                            picview: "",
                        },
                        outer_spacing: {
                            top: 12,
                            left: 12,
                        },
                        inner_spacing: {
                            top: 6,
                            left: 0,
                        },
                        rounded_corner_setting: {
                            top: 20,
                            bottom: 20,
                        },
                    },
                },
            ];
        },
        // 默认表单规则（填写次数/时间限制等）
        getDefaultRuleData() {
            return {
                who_type: "0",
                customer_ids: [],
                per_user_limit_type: "0",
                per_user_days: "",
                per_user_count: "",
                total_limit_type: "0",
                total_count: "",
                total_days: "",
                time_limit_type: "0",
                start_time: "",
                end_time: "",
            };
        },
        // 将操作项上的规则字段回显到 rule_data（编辑弹窗使用）
        setRuleDataFromItem(item) {
            item = item || {};
            this.rule_data = {
                who_type: item.who_type != null ? String(item.who_type) : "0",
                customer_ids: Array.isArray(item.customer_ids)
                    ? [...item.customer_ids]
                    : [],
                per_user_limit_type:
                    item.per_user_limit_type != null
                        ? String(item.per_user_limit_type)
                        : "0",
                per_user_days: item.per_user_days || "",
                per_user_count: item.per_user_count || "",
                total_limit_type:
                    item.total_limit_type != null
                        ? String(item.total_limit_type)
                        : "0",
                total_count: item.total_count || "",
                total_days: item.total_days || "",
                time_limit_type:
                    item.time_limit_type != null
                        ? String(item.time_limit_type)
                        : "0",
                start_time: item.start_time || "",
                end_time: item.end_time || "",
            };
        },
        // 后端 form 数据 -> 前端操作项结构（form_json 即表单设计数据）
        mapFormToControlItem(form) {
            const formList =
                typeof form.form_json === "string"
                    ? JSON.parse(form.form_json || "[]")
                    : form.form_json || [];
            return {
                id: form.id || 0,
                btn_title: form.btn_title || form.title || "操作标题",
                btn_title_color: form.btn_title_color || "#000",
                btn_desc: form.btn_desc || "操作说明",
                btn_desc_color: form.btn_desc_color || "#666",
                btn_text: form.btn_text || "操作",
                btn_text_color: form.btn_text_color || "#fff",
                btn_color: form.btn_color || "#FF761D",
                border_color: form.border_color || "#FF761D",
                bg_color: form.bg_color || "#f2f7fa",
                formList: Array.isArray(formList)
                    ? formList
                    : this.getDefaultFormList(),
                who_type: form.who_type != null ? String(form.who_type) : "0",
                customer_ids: Array.isArray(form.customer_ids)
                    ? form.customer_ids
                    : [],
                per_user_limit_type:
                    form.per_user_limit_type != null
                        ? String(form.per_user_limit_type)
                        : "0",
                per_user_days: form.per_user_days || "",
                per_user_count: form.per_user_count || "",
                total_limit_type:
                    form.total_limit_type != null
                        ? String(form.total_limit_type)
                        : "0",
                total_count: form.total_count || "",
                total_days: form.total_days || "",
                time_limit_type:
                    form.time_limit_type != null
                        ? String(form.time_limit_type)
                        : "0",
                start_time: form.start_time || "",
                end_time: form.end_time || "",
                sort: form.sort || 0,
            };
        },
        // 通过 template_diy_form_list 接口回显操作项列表，覆盖 content.controlList
        async loadControlList() {
            this.ensureComponentKey();
            this.ensureControlList();
            if (!this.content_id || !this.newFormData.key) {
                return;
            }
            try {
                const res = await template_diy_form_list({
                    diy_template_content_id: Number(this.content_id),
                    component_key: this.newFormData.key,
                });
                const rawList = (res.data && res.data.list) || res.data || [];
                if (Array.isArray(rawList) && rawList.length) {
                    const list = rawList
                        .slice()
                        .sort((a, b) => {
                            const sortA = a.sort != null ? Number(a.sort) : 0;
                            const sortB = b.sort != null ? Number(b.sort) : 0;
                            return sortA - sortB;
                        })
                        .map((form) => this.mapFormToControlItem(form));
                    this.$set(this.newFormData.content, "controlList", list);
                }
            } catch (err) {
                this.$Message.error(err.msg || "获取操作面板列表失败");
            }
        },
        getMemberList() {
            customer_select()
                .then((res) => {
                    this.member_list = res.data || [];
                })
                .catch((err) => {
                    this.$Message.error(err.msg || "获取人员列表失败");
                });
        },
        selectName(name) {
            this.name_id = name;
        },
        changeStyle(val) {
            if (val == 2 && this.newFormData.content.controlList.length > 1) {
                this.$Message.warning("多表单不可使用");
                return;
            }
            this.newFormData.content.style_value = val;
        },
        changeBgValue(e) {
            this.newFormData.content.bg_value = e;
        },
        openPicModal() {
            this.switch_modal = true;
        },
        async costPlannedAmountChange(param1, param2) {
            for (var i = 0; i < param1.length; i++) {
                this.newFormData.content.bg_img.picview = param1[i];
            }
            for (var i = 0; i < param2.length; i++) {
                this.newFormData.content.bg_img.value = param2[i];
            }
            this.$Message.destroy();
        },
        // 样式二：编辑单个操作项（样式二仅允许一个操作项）
        editStatus(index) {
            this.editIndex = index;
            const item = this.newFormData.content.controlList[index];
            this.form_data = {
                btn_title: item.btn_title,
                btn_desc: item.btn_desc,
                btn_text: item.btn_text,
                btn_title_color: item.btn_title_color,
                btn_desc_color: item.btn_desc_color,
                btn_text_color: item.btn_text_color,
                btn_color: item.btn_color,
                border_color: item.border_color,
                bg_color: item.bg_color,
            };
            this.formList = JSON.parse(JSON.stringify(item.formList));
            this.setRuleDataFromItem(item);
            this.addTitle = "编辑";
            this.addModal = true;
        },
        // 新增/编辑操作项弹窗：index >= 0 为编辑（回显），否则为新增（重置）
        addStatus(index) {
            this.editIndex = index;
            if (index >= 0) {
                // 编辑：回显已有操作项
                const item = this.newFormData.content.controlList[index];
                this.form_data = {
                    btn_title: item.btn_title,
                    btn_desc: item.btn_desc,
                    btn_text: item.btn_text,
                    btn_title_color: item.btn_title_color,
                    btn_desc_color: item.btn_desc_color,
                    btn_text_color: item.btn_text_color,
                    btn_color: item.btn_color,
                    border_color: item.border_color,
                    bg_color: item.bg_color,
                };
                this.formList = JSON.parse(JSON.stringify(item.formList));
                this.setRuleDataFromItem(item);
                this.addTitle = "编辑";
            } else {
                // 新增：重置表单
                this.form_data = {
                    btn_title: "操作标题",
                    btn_desc: "操作说明",
                    btn_text: "操作",
                    btn_title_color: "#000",
                    btn_desc_color: "#666",
                    btn_text_color: "#fff",
                    btn_color: "#FF761D",
                    border_color: "#FF761D",
                    bg_color: "#f2f7fa",
                };
                this.formList = this.getDefaultFormList();
                this.rule_data = this.getDefaultRuleData();
                this.addTitle = "新增操作";
            }
            this.addModal = true;
        },
        // 保存操作项：合并表单数据 + 表单规则，有 id 更新、无 id 新建（调 form_save）
        saveStatusEdit() {
            const data = {
                ...this.form_data,
                formList: JSON.parse(JSON.stringify(this.formList)),
                ...this.rule_data,
            };
            if (this.editIndex >= 0) {
                const origin =
                    this.newFormData.content.controlList[this.editIndex] || {};
                data.id = origin.id || 0;
            } else {
                data.id = 0;
            }
            const saveIndex =
                this.editIndex >= 0
                    ? this.editIndex
                    : this.newFormData.content.controlList.length;

            const commit = () => {
                if (this.editIndex >= 0) {
                    this.$set(
                        this.newFormData.content.controlList,
                        this.editIndex,
                        data
                    );
                } else {
                    this.newFormData.content.controlList.push(data);
                }
                this.addModal = false;
            };

            if (!this.content_id || !this.newFormData.key) {
                commit();
                return;
            }
            template_diy_form_save(this.buildSaveParams(data, saveIndex))
                .then((res) => {
                    if (res.data && res.data.id) {
                        data.id = res.data.id;
                    }
                    commit();
                    this.$Message.success("保存成功");
                })
                .catch((err) => {
                    this.$Message.error(err.msg || "保存失败");
                });
        },
        // 删除操作项：有 id 调 template_diy_form_del，无 id 仅本地移除
        delStatus(index) {
            const list = this.newFormData.content.controlList;
            if (list.length <= 1) {
                this.$Message.warning("至少保留一个操作");
                return;
            }
            const item = list[index];
            if (!item.id) {
                list.splice(index, 1);
                return;
            }
            template_diy_form_del({ id: item.id })
                .then(() => {
                    list.splice(index, 1);
                    this.$Message.success("删除成功");
                })
                .catch((err) => {
                    this.$Message.error(err.msg || "删除失败");
                });
        },
        // 上移/下移操作项，交换后批量保存排序
        moveStatus(index, step) {
            const list = this.newFormData.content.controlList;
            const target = index + step;
            if (target < 0 || target >= list.length) return;
            const temp = list[index];
            this.$set(list, index, list[target]);
            this.$set(list, target, temp);
            this.updateControlSort(true);
        },
        // 更新操作项排序标记，可选同步到后端
        updateControlSort(saveToServer = false) {
            const list = this.newFormData.content.controlList || [];
            list.forEach((item, index) => {
                item.sort = index;
            });
            if (saveToServer) {
                this.saveControlSort();
            }
        },
        // 批量保存排序：遍历 controlList 中有 id 的项，逐个调 form_save
        async saveControlSort() {
            if (!this.content_id || !this.newFormData.key) return;
            const list = this.newFormData.content.controlList || [];
            if (!list.some((item) => item.id)) return;
            try {
                await Promise.all(
                    list.map((item, index) => {
                        if (!item.id) return Promise.resolve();
                        return template_diy_form_save(
                            this.buildSaveParams(item, index)
                        );
                    })
                );
            } catch (err) {
                this.$Message.error(err.msg || "排序保存失败");
            }
        },
        // 打开「创建表单/修改表单」弹窗
        addForm() {
            this.formModal = true;
        },
        // addForm 回传设计好的表单数据
        handleFormSubmit(list) {
            console.log("handleFormSubmit", list);
            this.formList = list;
            this.formModal = false;
        },
        // 打开「表单规则」弹窗
        addRule() {
            this.ruleModal = true;
        },
        // 提交表单规则
        submitRule() {
            this.ruleModal = false;
        },
        // 开始时间选择回调
        handleStartTimeChange(val) {
            this.rule_data.start_time = val || "";
        },
        // 结束时间选择回调
        handleEndTimeChange(val) {
            this.rule_data.end_time = val || "";
        },
        // 构建操作项保存参数：form_json 存表单设计数据，颜色字段与规则字段平铺在顶层
        buildSaveParams(item, index) {
            return {
                diy_template_content_id: Number(this.content_id) || 0,
                component_key: this.newFormData.key,
                id: item.id || 0,
                title: item.btn_title || "",
                form_json: item.formList || [],
                btn_title: item.btn_title,
                btn_title_color: item.btn_title_color || "#000",
                btn_desc: item.btn_desc,
                btn_desc_color: item.btn_desc_color || "#666",
                btn_text: item.btn_text,
                btn_text_color: item.btn_text_color || "#fff",
                btn_color: item.btn_color,
                border_color: item.border_color,
                bg_color: item.bg_color,
                who_type: item.who_type != null ? Number(item.who_type) : 0,
                customer_ids: Array.isArray(item.customer_ids)
                    ? item.customer_ids
                    : [],
                per_user_limit_type:
                    item.per_user_limit_type != null
                        ? Number(item.per_user_limit_type)
                        : 0,
                per_user_days: item.per_user_days || 0,
                per_user_count: item.per_user_count || 0,
                total_limit_type:
                    item.total_limit_type != null
                        ? Number(item.total_limit_type)
                        : 0,
                total_count: item.total_count || 0,
                total_days: item.total_days || 0,
                time_limit_type:
                    item.time_limit_type != null
                        ? Number(item.time_limit_type)
                        : 0,
                start_time: item.start_time || "",
                end_time: item.end_time || "",
                sort: index,
            };
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: #ff761d;
}
.form-title {
    margin: 24px 0 12px;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
.section-label {
    margin-bottom: 8px;
    font-size: 14px;
    color: #666;
}
.status-list-box {
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 12px;
    background: #fff;
}
.status-item {
    position: relative;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 12px;
    margin-bottom: 12px;
    background: #fafafa;
}
.item-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 8px;
}
.action-link {
    color: #ff761d;
    cursor: pointer;
    margin-left: 12px;
    font-size: 13px;
}
.mt12 {
    margin-top: 12px;
}
.del-btn {
    margin-left: 12px;
    width: 28px;
    height: 28px;
    background: #ff761d;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.add-status {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 0;
    color: #ff761d;
    cursor: pointer;
    font-size: 14px;
}
.add-status span {
    margin-left: 4px;
}
.style-select {
    gap: 16px;
    margin-bottom: 12px;
}
.style-card {
    flex: 1;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 10px;
    cursor: pointer;
    background: #fff;
}
.style-card-active {
    border-color: #ff761d;
    box-shadow: 0 0 0 1px #ff761d;
}
.bg-upload {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #ccc;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.bg-img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
}
.w1 {
    width: 100%;
}
.control-grid {
    padding: 12px;
    background-color: #f2f7fa;
    border-radius: 5px;
    font-size: 14px;
    color: #666;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.control-name {
    margin-bottom: 3px;
    font-size: 16px;
    color: #000;
}
.control-tip {
    margin-top: 3px;
    font-size: 14px;
    color: #999;
}
.edit-div {
    padding: 12px;
    border-radius: 4px;
    border: 1px solid #9fa5bb;
}
.edit-name {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 15px;
    color: #484e66;
}
.edit-txt {
    margin-bottom: 6px;
    line-height: 20px;
}
.form-div {
    min-height: 200px;
    display: flex;
    align-items: center;
}
.radio-tip {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #747b95;
}
.w50 {
    width: 50px;
}
.time-range {
    display: flex;
    align-items: center;
}
.time-sep {
    margin: 0 8px;
}
::v-deep .ivu-menu-horizontal .ivu-menu-item-active,
::v-deep .ivu-menu-horizontal .ivu-menu-item:hover,
::v-deep .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active {
    color: #ff761d;
    border-bottom-color: #ff761d;
}
::v-deep .ivu-slider-bar {
    background-color: #ff761d;
}
::v-deep .ivu-slider-button {
    border: 2px solid #ff761d;
}
.form-modal ::v-deep .ivu-modal-body {
    padding: 12px 0 !important;
    background-color: #f5f6fa !important;
}
::v-deep .ivu-radio-checked .ivu-radio-inner {
    border: 2px solid #ff761d;
}
::v-deep .ivu-radio-inner:after {
    background-color: #fff;
}
</style>
